<template>
  <div class="section fondu" :class="{'fonduenter': titreform}">

    <!-- notification -->
    <transition mode="out-in" name="fade">
      <div v-if="notification.message" :class="'notification is-' + notification.type">
        <button class="delete" @click="hideNotifications"></button>{{notification.message}}
      </div>
    </transition>

    <div class="card">
      <div class="card-header">
        <p class="card-header-title">Routes</p>
        <span class="icon has-text-info help-btn">
          <a href="https://theadmin.thecompagnie.eu/doc?bloc=Paramètres" target="_blank"><i class="fa fa-question-circle"></i></a>
        </span>
      </div>
      <div class="card-content principal">
        <div class="content">
          <div class="card">
            <div class="card-header">
              <p class="card-header-title">{{titreform}}</p>
              <span class="icon has-text-info help-btn">
                <a href="https://theadmin.thecompagnie.eu/doc?bloc=Ajouter%20un%20lien" target="_blank"><i class="fa fa-question-circle"></i></a>
              </span>
            </div>
            <div class="card-content">
              <div class="content">
                <div class="field">
                  <span class="icon has-text-info help-btn">
                    <a href="https://theadmin.thecompagnie.eu/doc?bloc=Chemin" target="_blank"><i class="fa fa-question-circle"></i></a>
                  </span>
                  <label class="label">Chemin</label>
                  <div class="control">
                    <input class="input" type="text" v-model="form.path" placeholder="Ex: /path">
                  </div>
                </div>

                <div class="field">
                  <span class="icon has-text-info help-btn">
                    <a href="https://theadmin.thecompagnie.eu/doc?bloc=Template" target="_blank"><i class="fa fa-question-circle"></i></a>
                  </span>
                  <label class="label">Template</label>
                  <div class="select is-fullwidth">
                    <select v-model="form.template">
                      <option v-for="(template, i) in templates" :key="i" :value="template.filename">
                        {{template.displayName}}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="field">
                  <span class="icon has-text-info help-btn">
                    <a href="https://theadmin.thecompagnie.eu/doc?bloc=Type%20de%20contenu" target="_blank"><i class="fa fa-question-circle"></i></a>
                  </span>
                  <label class="label">Type de contenu</label>
                  <div class="select is-fullwidth">
                    <select v-model="form.contentType">
                      <option v-for="(type, i) in contentTypes" :key="i" :value="type">
                        {{type}}
                      </option>
                      <option value="none">Pas de type de contenu</option>
                    </select>
                  </div>
                </div>

                <div class="field">
                  <span class="icon has-text-info help-btn">
                    <a href="https://theadmin.thecompagnie.eu/doc?bloc=Contenu" target="_blank"><i class="fa fa-question-circle"></i></a>
                  </span>
                  <label class="label">Contenu</label>
                  <div class="select is-fullwidth">
                    <select v-model="form.content">
                      <option v-for="(content, i) in selectedContents" :key="i" :value="content['.key']">
                        {{content['.key']}}
                      </option>
                      <option value="none">Pas de contenu</option>
                    </select>
                  </div>
                </div>

                <!-- buttons -->
                <div class="field is-grouped">
                  <div class="control">
                    <button v-if="form.action === 'add'" class="button is-info" @click="addRoute">
                      Ajouter
                    </button>
                    <button v-if="form.action === 'update'" class="button is-info" @click="updateRoute">
                      Actualiser
                    </button>
                  </div>
                  <div class="control">
                    <button class="button" @click="clear">Annuler</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="card">
            <div class="card-header">
              <p class="card-header-title">Routes dynamiques</p>
              <span class="icon has-text-info help-btn">
                <a href="https://theadmin.thecompagnie.eu/doc?bloc=Routes%20dynamiques" target="_blank"><i class="fa fa-question-circle"></i></a>
              </span>
            </div>
            <div class="card-content">
              <div class="content">
                <ul>
                  <li v-for="(route, i) in routes" :key="i">
                    <b>Chemin: </b>
                    <a :href="route.path" target="_blank">{{route.path}}</a>

                    <span class="route-actions">
                      <span class="has-text-danger fa fa-trash" @click="deleteRoute(route['.key'])"></span>
                      <span class="has-text-info fa fa-edit" @click="editRoute(route)"></span>
                    </span>
                    <br />
                    <div class="route-details">
                      <span><b>Template: </b> {{getTemplateDisplayName(route.template)}}</span><br />
                      <span><b>Contenu: </b> {{selectContentByTypeAndId(route.contentType, route.content)['.key'] || 'Pas de contenu'}}</span>
                    </div><br />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <br />
          <div class="card">
            <div class="card-header">
              <p class="card-header-title">Routes réservées</p>
              <span class="icon has-text-info help-btn">
                <a href="https://theadmin.thecompagnie.eu/doc?bloc=Routes%20réservées" target="_blank"><i class="fa fa-question-circle"></i></a>
              </span>
            </div>
            <div class="card-content">
              <div class="content">
                <ul>
                  <li v-for="(route, i) in defaultRoutes" :key="i">
                    <router-link :to="route">{{route}}</router-link>
                  </li>
                </ul>
                <!-- dynamic routes list -->
                <span class="icon has-text-info help-btn">
                  <a href="https://theadmin.thecompagnie.eu/doc?bloc=Routes%20dynamiques" target="_blank"><i class="fa fa-question-circle"></i></a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { contentsRef, routesRef } from '@/admin/firebase_config'
import notifier from '@/admin/mixins/notifier'
import templates from '@/app/templates/templates.json'

export default {
  data () {
    return {
      titreform: 'Ajouter une route',
      form: {
        path: '/',
        template: templates[0].filename,
        contentType: 'none',
        content: 'none',
        action: 'add',
        key: ''
      },
      defaultRoutes: ['/', '/admin', '/login'],
      templates
    }
  },
  firebase: {
    contents: contentsRef,
    routes: routesRef
  },
  computed: {
    contentTypes () {
      return this.contents.map(content => {
        return content.name
      })
    },
    selectedContents () {
      return this.getContentsByType(this.form.contentType)
    }
  },
  mixins: [notifier],
  methods: {
    selectContentByTypeAndId (type, id) {
      let contentsByType = this.getContentsByType(type)
      return contentsByType.filter(content => content['.key'] === id)[0] || {}
    },
    addRoute () {
      if (this.isPathAvailable(this.form.path)) {
        this.$firebaseRefs.routes.push({
          path: this.form.path.trim(),
          template: this.form.template,
          contentType: this.form.contentType,
          content: this.form.content
        })
          .then((res) => {
            let template = this.form.template
            this.showNotification('success', 'Route added successfully')
            this.$router.addRoutes([{
              path: this.form.path,
              component: () => import(`@/app/templates/${template}.vue`)
            }])
            this.clear()
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        this.showNotification('danger', 'A route with the same path already exists')
      }
    },
    editRoute (route) {
      this.titreform = 'Éditer une route'
      this.form.content = route.content
      this.form.template = route.template
      this.form.contentType = route.contentType
      this.form.path = route.path
      this.form.action = 'update'
      this.form.key = route['.key']
    },
    updateRoute () {
      this.$firebaseRefs.routes.child(this.form.key).set({
        content: this.form.content,
        path: this.form.path.trim(),
        template: this.form.template,
        contentType: this.form.contentType
      })
        .then(() => {
          let template = this.form.template
          this.showNotification('success', 'Route Updated successfully')
          this.$router.addRoutes([{
            path: this.form.path,
            component: () => import(`@/app/templates/${template}.vue`)
          }])
          this.clear()
        })
    },
    deleteRoute (key) {
      this.$firebaseRefs.routes.child(key).remove()
        .then(() => {
          this.showNotification('success', 'Route deleted successfully')
        })
    },
    clear () {
      this.titreform = 'Ajouter une route'
      this.form.key = ''
      this.form.path = '/'
      this.form.content = ''
      this.form.template = templates[0].filename
      this.form.action = 'add'
    },
    isPathAvailable (path) {
      let existingPaths = this.routes.map(route => {
        return route.path
      })
      existingPaths = existingPaths.concat(this.defaultRoutes)
      return !existingPaths.includes(this.form.path.trim())
    },
    getTemplateDisplayName (filename) {
      let displayName = ''
      templates.forEach(template => {
        displayName = template.filename === filename ? template.displayName : displayName
      })
      return displayName
    },
    getContentsByType (contentType) {
      let selectedContentsData = []
      let selectedContents = this.contents.filter(content => {
        return content.name === contentType
      })
      selectedContents.forEach(content => {
        let contentDataArray = this.convertContentDataToArray(content.data)
        selectedContentsData = selectedContentsData.concat(contentDataArray || [])
      })
      return selectedContentsData
    },
    convertContentDataToArray (contentData) {
      let contentDataArray = []
      for (let key in contentData) {
        contentDataArray.push({
          ...contentData[key],
          '.key': key
        })
      }
      return contentDataArray
    }
  },
  watch: {
    form: {
      deep: true,
      handler () {
        if (this.form.contentType === 'none') {
          this.form.content = 'none'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.section{
  padding: 0 !important;
  padding-top: 1em !important;
}
.bulma .card .card-content.principal{
  padding: 0 !important;
}
.bulma .card-content{
  padding: 0 !important;
}
.bulma .columns{
  padding: 0 !important;
}
.bulma .column{
  padding: 0 !important;
}
.content{
  padding: 1em !important;
}
</style>



// WEBPACK FOOTER //
// src/admin/pages/Routing.vue